document.addEventListener('DOMContentLoaded', function() {
  let cartIsUpdating = false;
  let lastCartUpdateTimestamp = 0;
  let swiperInitializing = false;
  let lastCartDrawerOpenTime = 0;
  
  const waitFor = async (conditionFn, timeout = 10000, interval = 100) => {
    const startTime = Date.now();
    
    while (Date.now() - startTime < timeout) {
      if (conditionFn()) {
        return true;
      }
      await new Promise(resolve => setTimeout(resolve, interval));
    }
    
    return false;
  };
  
  const isCartUpdateComplete = () => {
    const timeSinceLastUpdate = Date.now() - lastCartUpdateTimestamp;
    return !cartIsUpdating && timeSinceLastUpdate > 500;
  };
  
  const isCartDrawerSettled = () => {
    const timeSinceOpen = Date.now() - lastCartDrawerOpenTime;
    return timeSinceOpen > 1000; // Wait at least 1 second after drawer opens
  };
  
  const initCalloutSwiper = async () => {
    if (document.querySelector('.discount-callouts-swiper') && !swiperInitializing) {
      swiperInitializing = true;
      // document.querySelector('.discount-callouts-swiper').style.display = 'none';
      
      // Check if cart drawer has been open for at least 1 second
      if (!isCartDrawerSettled()) {
        console.log('Waiting for cart drawer to settle...');
        await waitFor(isCartDrawerSettled, 500, 100);
      }
      
      // Check if cart update is complete
      if (!isCartUpdateComplete()) {
        console.log('Waiting for cart update to complete...');
        await waitFor(isCartUpdateComplete, 500, 100);
      }
      
      // Give a small delay for DOM to settle
      await new Promise(resolve => requestAnimationFrame(resolve));
      
      const slides = document.querySelectorAll('.discount-callouts-swiper .swiper-slide');
      let hasVisibleSlides = false;
      let visibleSlides = [];
      
      slides.forEach(slide => {
        const calloutContainer = slide.querySelector('.cart-drawer-discount-callout-container');
        if (calloutContainer && calloutContainer.style.display === 'none') {
          slide.classList.add('swiper-slide-hidden');
          slide.setAttribute('aria-hidden', 'true');
        } else {
          hasVisibleSlides = true;
          visibleSlides.push(slide);
        }
      });
      
      if (hasVisibleSlides) {
        const swiperWrapper = document.querySelector('.discount-callouts-swiper .swiper-wrapper');
        
        if (swiperWrapper) {
          swiperWrapper.innerHTML = '';
          
          visibleSlides.forEach(slide => {
            swiperWrapper.appendChild(slide);
          });
          
          // Make sure Swiper is loaded before initializing
          if (typeof Swiper === 'function') {
            new Swiper('.discount-callouts-swiper', {
              slidesPerView: visibleSlides.length === 1 ? 1 : 1.1,
              spaceBetween: 16,
              grabCursor: true,
              pagination: {
                el: '.discount-callouts-swiper .swiper-pagination',
                clickable: true,
              },
              loop: false
            });
            
            document.querySelector('.discount-callouts-swiper').style.display = 'block';
          } else {
            console.error('Swiper not loaded');
          }
        }
      } else {
        document.querySelector('.discount-callouts-swiper').style.display = 'none';
      }
      
      swiperInitializing = false;
    }
  };
  
  const handleCartUpdate = async () => {
    cartIsUpdating = true;
    lastCartUpdateTimestamp = Date.now();
    
    const carousel = document.querySelector('.discount-callouts-swiper');
    if (carousel) {
      carousel.style.display = 'none';
    }
    
    // Use DOM readiness detection instead of fixed timeout
    const checkCartLoading = () => {
      const loadingIcon = document.querySelector('.loading-icon');
      if (!loadingIcon) {
        // Loading is complete
        cartIsUpdating = false;
        
        // Initialize swiper after a small delay to ensure DOM has settled
        setTimeout(() => {
          initCalloutSwiper();
        }, 1000); // Wait 1 second after loading is complete
      } else {
        // Check again in a short interval
        setTimeout(checkCartLoading, 100);
      }
    };
    
    // Start checking for loading completion
    setTimeout(checkCartLoading, 500);
  };

  // Monitor cart drawer open/close events
  const cartDrawerObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const cartDrawer = mutation.target;
        if (cartDrawer.classList.contains('expanded-v2')) {
          console.log('Cart drawer opened');
          lastCartDrawerOpenTime = Date.now();
          // Cart drawer was just opened
          setTimeout(() => {
            initCalloutSwiper();
          }, 1000); // Wait 1 second after drawer opens
        }
      }
    });
  });
  
  // Start observing the cart drawer
  const cartDrawer = document.querySelector('.cart-drawer');
  if (cartDrawer) {
    cartDrawerObserver.observe(cartDrawer, { attributes: true });
  }

  const initImmediateSwiper = async () => {
    if (document.querySelector('.discount-callouts-swiper')) {
      // Record the time when cart drawer is opened
      lastCartDrawerOpenTime = Date.now();
      
      // Check if cart drawer is visible before initializing
      const isCartDrawerVisible = () => {
        const cartDrawer = document.querySelector('.cart-drawer.expanded-v2');
        return cartDrawer && getComputedStyle(cartDrawer).display !== 'none';
      };
      
      // If cart drawer is visible, wait and then initialize the swiper
      if (isCartDrawerVisible()) {
        // Wait 1 second for cart drawer to fully load
        await new Promise(resolve => setTimeout(resolve, 1000));
        await initCalloutSwiper();
      } else {
        // Wait for cart drawer to become visible
        await waitFor(isCartDrawerVisible, 3000, 50);
        // Then wait 1 more second
        await new Promise(resolve => setTimeout(resolve, 1000));
        await initCalloutSwiper();
      }
    }
  };

  document.querySelector('.btn-cart.js-cart-btn').addEventListener('click', () => {
    lastCartDrawerOpenTime = Date.now();
    initImmediateSwiper();
  });
  
  if (document.querySelector('.cart-drawer.expanded-v2')) {
    lastCartDrawerOpenTime = Date.now();
    handleCartUpdate();
  }
  
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this._isCartRequest = url.includes('/cart/add.js') || 
                          url.includes('/cart/update.js') || 
                          url.includes('/cart/change.js') || 
                          url.includes('/cart/clear.js');
    originalOpen.apply(this, [method, url, ...args]);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this._isCartRequest) {
      cartIsUpdating = true;
      lastCartUpdateTimestamp = Date.now();
      
      this.addEventListener('load', function () {
        // Use requestAnimationFrame for better timing
        requestAnimationFrame(() => {
          lastCartUpdateTimestamp = Date.now();
          handleCartUpdate();
        });
      });
    }
    originalSend.apply(this, [body]);
  };
  
  document.addEventListener('click', function(e) {
    if (e.target && (e.target.classList.contains('js-cart-remove') || 
                    e.target.closest('.js-cart-remove'))) {
      cartIsUpdating = true;
      lastCartUpdateTimestamp = Date.now();
      handleCartUpdate();
    }
  });
  
  document.addEventListener('change', function(e) {
    if (e.target && (
      e.target.classList.contains('cart__qty-input') || 
      e.target.closest('.cart__qty-input')
    )) {
      cartIsUpdating = true;
      lastCartUpdateTimestamp = Date.now();
      handleCartUpdate();
    }
  });
});